<!-- The button that triggers the popover. It needs a reference variable like #op to toggle the panel. -->
<button type="button" class="layout-topbar-action" (click)="op.toggle($event)">
  <i class="pi pi-user"></i>
</button>

<!-- The Popover content -->
<p-overlayPanel #op appendTo="body" [showCloseIcon]="true" [dismissable]="true">
  <div class="flex flex-col gap-2 p-2 min-w-[200px]">
    
    <!-- User Information Header -->
    <div class="flex items-center gap-2">
      <i class="pi pi-user text-xl"></i>
      <div class="flex flex-col">
        <span class="text-sm font-semibold">{{ user.displayName }}</span>
        <span class="text-xs text-gray-500">{{ user.email }}</span>
      </div>
    </div>
    
    <p-divider></p-divider>
    
    <!-- Action Buttons -->
    <button pButton type="button" label="View Profile" icon="pi pi-id-card" (click)="onProfileClick(); op.hide()"
      class="p-button-text p-button-plain p-button-sm w-full justify-content-start"></button>
      
    <button pButton type="button" label="Settings" icon="pi pi-cog" (click)="onSettingsClick(); op.hide()"
      class="p-button-text p-button-plain p-button-sm w-full justify-content-start"></button>
      
    <p-divider></p-divider>
    
    <button pButton type="button" label="{{ translateServ.dictionary['SIGN_OUT'] || 'Sign Out' }}" icon="pi pi-sign-out" (click)="onSignOutClick(); op.hide()"
      class="p-button-text p-button-danger p-button-sm w-full justify-content-start"></button>
      
  </div>
</p-overlayPanel>

